import { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

const useDocumentConfig = () => {
  const { user } = useAuth();

  const [config, setConfig] = useState({
    advogado: '',
    oa: '',
    domicilio: 'Av. da República, 32 -1° Dto, 1050-193 Lisboa',
    apiBaseUrl: 'https://sniperspt.pythonanywhere.com',
    modeloIdentificarDados: 'gpt-4o-mini',
    modeloCriarProcuracao: 'o1-mini'
  });
  const [showConfig, setShowConfig] = useState(false);

  useEffect(() => {
    if (user) {
      setConfig(prev => ({
        ...prev,
        advogado: user.nome || '',
        oa: user.documento || ''
      }));
    }
  }, [user]);

  const handleConfigChange = (field, value) => {
    setConfig(prev => ({ ...prev, [field]: value }));
  };

  return { config, showConfig, setShowConfig, handleConfigChange };
};

export default useDocumentConfig;
